import React from 'react';

import { List } from './List';
import { View } from './View';
import { Edit } from './Edit';

export const businessRoutes = {
  path: '/business',
  children: [
    {
      path: '',
      element: <List />,
    },
    {
      path: ':id',
      element: <View />,
    },
    {
      path: ':id/edit',
      element: <Edit />,
    },
  ],
};
